// extracted by mini-css-extract-plugin
module.exports = {"container":"TabNavBar_container__2NU8_","inner":"TabNavBar_inner__2czk5","items":"TabNavBar_items__3yAXL","sending":"TabNavBar_sending__1AdAH"};